import { ArrowCircleRightSharp, CancelRounded, DirectionsBike } from "@mui/icons-material";
import { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useHistory, useLocation } from 'react-router-dom';
import { isFreshPageLoad } from '../../DTechComp/NavigationTracker';
import { Link, Route, Switch, useParams, useRouteMatch } from "react-router-dom";
import ConnUrls from "../../Connections/ConnectURL";
import { CurrentPContext, MasterContext, MessagesObjCssContext, MobiOrNotContext, OrderContext, UserContext } from "../../ContextApi/context";
import BigPopUpMsg from "../../DTechComp/BigPopUpMsg";
import ContinueToPayLine from "../../DTechComp/ContinueToPayLine";
import MyDateTime from "../../DTechComp/MyDateTime";
import ScrollingSaver from "../../DTechComp/ScrollingSaver";
import OrderFunctions from "../../OrderSettings/OrderFunctions";
import utilsRests from "../../_Utils/utilsRests";
import myFunctions, { getDiallable, getPhoneDisplay } from "../../myFunctions";
import PhoneLink from "../../DTechComp/PhoneLink";
import MoreDetails from "./MoreDetails";
import BuisRating from "./RestDetails/BuisRating";
import DayOpeningHours from "./RestDetails/DayOpeningHours";
import AddressLine from "./RestDetails/addressLine";
import RestMnu from "./RestMnu";
import PopUpMsg from "../../DTechComp/PopUpMsg";
import TopBigSlides from "../../DTechComp/TopBigSlides";
import TblOrderReservation from "./ForTableReservation/TblOrderReservation";
import PopUpTheComp from "../../DTechComp/PopUpTheComp";
import OrderTypeSelect from "../../OrderSettings/OrderTypeSelect";
import utilsOrders from "../../_Utils/utilsOrders";
import utilsUsers from "../../_Utils/utilsUsers";
import PopUp2Buttons from "../../DTechComp/PopUp2Buttons";
import TopSmallSlides from "../../DTechComp/TopSmallSlides";
import PopUpOneLine from "../../DTechComp/PopUpOneLine";
import MySpinner_Wait from "../../DTechComp/MySpinner_Wait";
import RestSuperMenu from "./RestSuperMenu";
import WaitImgOverlay from '../../DTechComp/WaitImgOverlay';
import { isExternalUrl, openViaApp } from '../../DTechComp/AppPromo/appEnv';



const RestaurantPage = (props) => {

    let { path, url } = useRouteMatch();
    const history = useHistory();
    // const [theData] = useState(TheSrc());
    const [user] = useContext(UserContext);
    const [order, setOrder] = useContext(OrderContext);
    const [master, setMaster] = useContext(MasterContext);
    const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
    const [currentPage, setCurrentPage] = useContext(CurrentPContext);
    const [openingHours, setOpeningHours] = useState();
    const [buisAddress, setBuisAddress] = useState();
    const [delTiming, setDelTiming] = useState();
    const [rating, setRating] = useState();
    const [doDeliver, setDoDeliver] = useState(currentPage.Delivery?.Doing);
    const [doTakeAway, setDoTakeAway] = useState(currentPage.TakeAway?.Doing);
    const [stickyShow, setStickyShow] = useState(false);
    const [mousePosi, setMousePosi] = useState({ x: "5px", y: "43%" });
    const [mov, setMov] = useState(false);

    const [restMnu, setRestMnu] = useState();
    const [moreDetailsPage, setMoreDetailsPage] = useState();
    const [showHideMoreDet, setShowHideMoreDet] = useState("hideOnLeft");
    const [lsidetuff, setLsideStuff] = useState();

    const [loading, setLoading] = useState(true);
    const [thePopUp, setThePopUp] = useState("");

    const params = useParams();
    // const location = useLocation();

    const [bgImgPos, setBgImgPos] = useState("");
    const [waitImgItm, setWaitImgItm] = useState({});
    const [shHidMoreDetails, setShHidMoreDetails] = useState(false);

    const [dispOnlyDelivery, setDispOnlyDelivery] = useState(true);
    const [googleSchem, setGoogleSchem] = useState();
    const [breadcrumbSchema, setBreadcrumbSchema] = useState();

    const [buissMainImgDeskTop, setBuissMainImgDeskTop] = useState(currentPage.buissMainImgDeskTop);
    const [buissMainImgDeskTop2, setBuissMainImgDeskTop2] = useState(currentPage.buissMainImgDeskTop2 || "");
    const [buissMainImg, setBbuissMainImg] = useState(currentPage.buissMainImg);

    const [notGettinOrders, setNotGettinOrders] = useState("");
    //הפס התחתון לעסק שמאפשר הזמנת שולחן. מחושב באותו מקום שבו
    //מחושבים הערוצים, כי הוא תלוי בשעות ובהשהיות ולא רק במתגים
    const [reservOnlyTxt, setReservOnlyTxt] = useState("");

    const [userLast2Ordrs, setUserLast2Ordrs] = useState([]);

    const [thePrompt, setThePrompt] = useState()

    const [messagesObjCss, setMessagesObjCss, goSetTheMsgDisp, siteMessages, setSiteMessages] = useContext(MessagesObjCssContext);

    useEffect(() => {
        if (currentPage?.restMessages && currentPage.restMessages.length > 0) {
            goSetTheMsgDisp(currentPage.restMessages);
        }
    }, [currentPage?.restMessages]);
    // const lochrf = window.location.pathname;

    useEffect(() => {

        //currentPage עדיין של העמוד הקודם עד ש-getRestData מסתיים, ולכן הוא היה
        //מציג לרגע את תמונת המאסטר לפני תמונת העסק. עד אז נשאר מסך לבן.
        if (currentPage?._id === props.restId || master?.imgWaitingActive === false) {
            setWaitImgItm(myFunctions.setTheImgWait(currentPage, master, mobiOrNot));
        }

        if (order.Orders <= 0 && (history.action !== "POP" || isFreshPageLoad())) props.scrollToTop(0);
        props.shoTopStrp(false)

        setPrompt();
        // checkUserBeenhere();
        getRestData();
        setLoading(false);
    }, []);


    //אם עוד פרטים מוצג כפתור החזרה יחזיר ישירות לעמוד העסק
    useEffect(() => {

        const handlePopState = (event) => {
            if (shHidMoreDetails) {
                history.push(props.refrshPath)
            }
        };

        // window.removeEventListener('popstate', handlePopState);
        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [shHidMoreDetails]);


    useEffect(() => {

        if (currentPage != null) {
            creatGoogleSchema()
            createBreadcrumbSchema()

            setBuissMainImgDeskTop(currentPage.buissMainImgDeskTop);
            setBuissMainImgDeskTop2(currentPage.buissMainImgDeskTop2 || "");
            setBbuissMainImg(currentPage.buissMainImg);
        }


    }, [currentPage])

    // //בודק אם לקוח כבר היה פה ויש לו הזמנות מהעסק הנוכחי אולי הוא רוצה פשוט לשכפל הזמנה
    // const checkUserBeenhere = async () => {

    // }

    const creatGoogleSchema = () => {
        if (currentPage.buissName) {
            let theSchem =
            {
                "@context": "https://schema.org/",
                "@type": "Restaurant",
                "name": currentPage.buissName,
                "image": ConnUrls.media(currentPage.buissMainImg),
                // כשאין מספר של המסעדה השדה פשוט לא נכלל. קודם הוזן כאן 0777017003 -
                // המספר שלנו - כך שגוגל הציג אותו כטלפון של המסעדה וחיוגים גלשו אלינו.
                // בנוסף, הבדיקה שהייתה כאן השתמשה ב-validPhone כאילו היא בוליאנית, אבל
                // היא מחזירה הודעת שגיאה ומחרוזת ריקה משמעה תקין - ולכן פעלה הפוך,
                // ודווקא מספרים תקינים הוחלפו במספר שלנו.
                ...(getDiallable(currentPage.buissPhone)
                    ? { "telephone": getDiallable(currentPage.buissPhone) }
                    : {}),
                "address": {
                    "@type": "PostalAddress",
                    "streetAddress": currentPage.buissAddress ? myFunctions.getOnlyaddress({ address: currentPage.buissAddress }).mainAddress : "",
                    "addressLocality": "אשדוד",
                    "addressCountry": "IL"
                },
                "priceRange": "10-150",
                "description": currentPage.sEOdescription,
                "aggregateRating": {
                    "@type": "AggregateRating",
                    "bestRating": "5",
                    "ratingValue": currentPage.buissRating !== "" ? currentPage.buissRating : "4",
                    "worstRating": "1",
                    "reviewCount": 98
                },
                "servesCuisine": currentPage.buissKitchType,
                //schema.org מצפה ל-"HH:mm". ימים סגורים מושמטים
                "openingHoursSpecification": (currentPage.OpeningHours || [])
                    .filter((element) => element && element.Closed !== true &&
                        MyDateTime.normalizeHM(element.Open) !== "" &&
                        MyDateTime.normalizeHM(element.Close) !== "")
                    .map((element) => ({
                        "@type": "OpeningHoursSpecification",
                        "dayOfWeek": element.Day,
                        "opens": MyDateTime.normalizeHM(element.Open),
                        "closes": MyDateTime.normalizeHM(element.Close)
                    })),
                "additionalProperty": {
                    "@type": "PropertyValue",
                    "name": "About",
                    "value": currentPage.buissAbout
                },
                "hasMenu": ConnUrls.siteDomainNam + `/restaurants/${currentPage.pageUrlFix !== null && currentPage.pageUrlFix !== "" ? currentPage.pageUrlFix : currentPage._id}`,
                "paymentAccepted": "אשראי, ביט, מזומן",
                "url": ConnUrls.siteDomainNam + `/restaurants/${currentPage.pageUrlFix !== null && currentPage.pageUrlFix !== "" ? currentPage.pageUrlFix : currentPage._id}`
            }


            setGoogleSchem(JSON.stringify(theSchem))
        }

    }

    const createBreadcrumbSchema = () => {
        if (currentPage.buissName) {
            const breadcrumb = {
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": [
                    {
                        "@type": "ListItem",
                        "position": 1,
                        "name": "דף הבית",
                        "item": ConnUrls.siteDomainNam
                    },
                    {
                        "@type": "ListItem",
                        "position": 2,
                        "name": currentPage.buissName,
                        "item": `${ConnUrls.siteDomainNam}/restaurants/${currentPage.pageUrlFix !== null && currentPage.pageUrlFix !== "" ? encodeURIComponent(currentPage.pageUrlFix) : currentPage._id}`
                    }
                ]
            };
            setBreadcrumbSchema(JSON.stringify(breadcrumb));
        }
    }

    const popMoreDetails = () => {
        setShHidMoreDetails(!shHidMoreDetails)
    }

    // הלקוח הגיע לעסק חדש עם סל שכבר מכיל מוצרים מעסק אחר.
    // לא מוחקים לו בשקט — הוא בוחר אם להתחיל מחדש או לחזור להזמנה הקודמת.
    // זו ההגנה היחידה שצריך מפני סל מעורב, והיא רצה לפני שאפשר להוסיף מוצר.
    const askAboutOtherRestCart = (storedOrder, restPage) => {
        const prevName = storedOrder.restName || "עסק אחר";

        setThePopUp(
            <PopUpOneLine
                cssStyl={"specialPopComp onTopOfAll noPadding"}
                key={"otherRestCart"}
                topTitle={"לתשומת לבך"}
                Title={[`יש לך מוצרים מ${prevName} בסל`,
                `אפשר להזמין מעסק אחד בכל פעם`]}
                inLabel={""}
                closeFunc={() => setThePopUp()}
                btn1Txt={`התחל הזמנה חדשה מ${restPage.buissName}`}
                btn1Clck={() => {
                    setOrder(OrderFunctions.clearOrd());
                    setThePopUp();
                }}
                btn2Txt={`חזור להזמנה מ${prevName}`}
                btn2Clck={() => {
                    setThePopUp();
                    history.push(`/restaurants/${storedOrder.restId}`);
                }}
            />
        )
    }

    const getRestData = async () => {

        let temp_doDeliver = true;
        let temp_doTakeAway = true;

        try {
            let restPage = await utilsRests.getRestByIdWitUnPublished(props.restId);
            if (restPage == null) {
                //עסק ב-restStatus חסום, או עסק שלא קיים.
                //404 ולא פופאפ - העמוד לא אמור להתקיים בכלל
                goTo404();
                return;
            }
            else if (restPage) {

                // הגענו לעמוד של עסק אחר מזה שבסל.
                // קוראים את הסל מהאחסון ולא מה-state: אנחנו בתוך פונקציה
                // אסינכרונית, וה-order מה-closure עלול להיות לא מעודכן —
                // זו הסיבה שההגנה הזו פספסה בעבר ונוצרו סלים מעורבים.
                const storedOrder = OrderFunctions.readStoredOrder() || order;

                if (OrderFunctions.cartBelongsToOtherRest(storedOrder, restPage._id)) {
                    // יש מוצרים של עסק אחר — הלקוח מחליט, לא מוחקים לו בשקט
                    askAboutOtherRestCart(storedOrder, restPage);
                }
                else if (storedOrder.restId !== restPage._id) {
                    // סל ריק או של אותו עסק — איפוס שקט, אין מה לאבד
                    setOrder(OrderFunctions.clearOrd())
                }


                //restStatus חסום כבר סונן למעלה (השרת מחזיר null).
                //הבדיקה נשארת כהגנה כפולה למקרה של שרת לא מעודכן
                if (restPage.restStatus === "לא פעיל" || restPage.restStatus === "לא מפורסם") {
                    goTo404();
                    return;
                }
                //שעות הפתיחה לא חוסמות יותר את דף העסק - הן תווית בלבד.
                //כל ערוץ נפתח לפי השעות שלו למטה

                setCurrentPage({ ...restPage, pageTYp: "withConPay" });


                //שלושת הערוצים בקריאה אחת. אין יותר עטיפה של
                //"שעות הפתיחה סגורות -> הכל סגור"
                const chans = MyDateTime.resolveBusinessChannels(restPage, master);

                let Deliver = chans.deliveryOk;
                let Take = chans.takeAwayOk;

                setDoDeliver(Deliver)
                setDoTakeAway(Take)

                temp_doDeliver = Deliver;
                temp_doTakeAway = Take;

                setOpeningHours(<DayOpeningHours item={restPage} master={master} />);
                setBuisAddress(restPage.buissAddress ? <AddressLine address={restPage.buissAddress} /> : "");

                let timing = (restPage.Delivery?.Time) ? restPage.Delivery.Time : (restPage.TakeAway?.Time) ? restPage.TakeAway.Time : 30;
                let timingChannel = (restPage.Delivery?.Time) ? "Deliver" : "Take";
                timing = myFunctions.checkForDeliverysDelay(master, timing, timingChannel);

                let delTim = (
                    <div className={"pgSmallTxt"} >
                        <div className={"theImgwrap"} >
                            <div className={"theImg onRight"} style={{ paddingLeft: "10px", marginRight: "-4px" }} >
                                <DirectionsBike />
                            </div>
                        </div>
                        <div className={"timeTxt"}>
                            {(parseInt(timing) + 10) +
                                " - " + parseInt(timing)} דק'
                        </div>
                    </div >
                )
                setDelTiming(delTim)

                setRating(<BuisRating rating={restPage.buissRating} restId={restPage._id} />);

                if (!restPage.chkIsSuperMarket) {
                    setRestMnu(<RestMnu buisMenu={restPage.buisMenu}
                        showMoreDet={() => { setShHidMoreDetails(!shHidMoreDetails) }}
                        nameBuis={restPage.buissName}
                        restPage={restPage}
                        delTiming={delTim}
                        doDeliver={temp_doDeliver}
                        doTakeAway={temp_doTakeAway}
                        dispOnlyDelivery={dispOnlyDelivery} BuisId={restPage._id}
                        setDispOnlyDelivery={() => setDispOnlyDelivery(!dispOnlyDelivery)}
                        orderMeATable={() => orderMeATable()} />
                    );
                }
                else {

                    setRestMnu(<RestSuperMenu supermarketMenu={restPage.supermarketMenu}
                        showMoreDet={() => { setShHidMoreDetails(!shHidMoreDetails) }}
                        nameBuis={restPage.buissName}
                        restPage={restPage}
                        delTiming={delTim}
                        doDeliver={temp_doDeliver}
                        doTakeAway={temp_doTakeAway}
                        dispOnlyDelivery={dispOnlyDelivery} BuisId={restPage._id}
                        setDispOnlyDelivery={() => setDispOnlyDelivery(!dispOnlyDelivery)}
                        orderMeATable={() => orderMeATable()} />
                    );
                }

                setLsideStuff(
                    <>
                        <PhoneLink phone={restPage.buissPhone} className={"overFlHid"}>
                            <div className={"phoneLine"}>
                                <div className="clickPhoneBtn">{getPhoneDisplay(restPage.buissPhone)}</div>
                            </div>
                        </PhoneLink>
                        {delTiming}
                        <div className={"detailsLine moreDetBtn"}>
                            <div className={"bold"} onClick={() => popMoreDetails()}>
                                <span>עוד פרטים</span>
                            </div>
                        </div>

                        <div className={"detailsLine moreDetBtn"}>
                            <div className={"bold"}>
                                {/* <span>הזמנה עתידית</span> */}
                            </div>
                        </div>
                        <div className={"detailsLine moreDetBtn"}>
                            {/* <div className={"bold"} onClick={() => setDispOnlyDelivery(!dispOnlyDelivery)}>
                                <span>{(dispOnlyDelivery) ? "הצג תפריט מלא" : "הצג תפריט משלוחים"} </span>
                            </div> */}
                        </div>
                    </>
                )

                setWaitImgItm(myFunctions.setTheImgWait(restPage, master, mobiOrNot));

                setNotGettinOrders(myFunctions.notGettinOrders(master, restPage, chans));
                setReservOnlyTxt(myFunctions.reservationOnlyStrip(master, restPage, chans));
            }

        }
        catch (error) {
            // console.log(error)
            setBigPop("לא פעיל");
            //בלי זה restMnu נשאר undefined לנצח ומסך ההמתנה לא נעלם
            setRestMnu(<></>);
        }


    }

    //עסק ב-restStatus חסום ("לא פעיל" / "לא מפורסם") או שלא קיים -
    //העמוד שלו לא אמור להתקיים. replace ולא push, כדי שכפתור
    //"חזור" לא יחזיר את הלקוח לכתובת השבורה.
    //ב-next-ssg זה כבר 404 אמיתי דרך notFound:true
    const goTo404 = () => {
        history.replace('/err404');
    }

    let popTiming = -1;
    //נקרא כיום רק מה-catch, כלומר על תקלה לא צפויה בטעינת העסק.
    //restStatus חסום מטופל ב-goTo404 ולא כאן
    const setBigPop = (typ) => {
        popTiming++;
        setThePopUp(

            <PopUpMsg key={popTiming}
                nosnippet={true}
                Title={["אופססס!!!"]}
                cssStyl={"okPOP"}
                topSlides={<TopBigSlides swiperCss={"spopImage"} TopImages={[{ img: master.oopsPopImg, txt: "" }]} />}
                ContentText={["עסק זה כרגע לא פעיל",
                    "להזמנות באתר"]}
                inLabel={""}
                okClick={() => { history.push(`/`) }}
                btn1Css={"btnGreen bold btnPoppadding15"}
                errorMsg={""} />

        )
    }

    const orderMeATable = () => {
        setThePopUp(
            <PopUpTheComp
                // closePop={() => { props.stickyShow(true); setThePopUp() }}
                closePop={() => { setThePopUp() }}
                cssStyl={"OrderTblPop onTopOfAll"}
                theInsideComp={
                    <TblOrderReservation closeMe={() => setThePopUp()} />}
                Title={[""]}
            />
        )
    }

    //אם המשתמש הגיע ישירות (קישור חיצוני/רענון) אין לו היסטוריית ניווט באתר,
    //ו-goBack() עלול לצאת מהאתר או לא לעשות כלום - אז נופלים חזרה לעמוד הבית
    const goBackOrHome = () => {
        if (history.length > 2) {
            history.goBack();
        } else {
            history.push("/");
        }
    }

    const goToBack = () => {

        if (order.Orders?.length > 0) {
            setThePopUp(
                <PopUpOneLine
                    cssStyl={"specialPopComp onTopOfAll noPadding"}
                    key={popTiming}
                    topTitle={"לתשומת לבך"}
                    Title={["יש הזמנה פעילה", "יציאה תוביל לאובדן הנתונים"]}
                    inLabel={""}
                    closeFunc={() => setThePopUp()}
                    btn1Clck={() => setThePopUp()}
                    btn1Txt={"המשך להזמין"}
                    btn2Txt={"צא בכל זאת"}
                    btn2Clck={() => {
                        setOrder(OrderFunctions.clearOrd())
                        goBackOrHome();
                        setThePopUp();

                    }}
                />
            )

        }
        else {
            goBackOrHome();
        }

        return ""
    }


    const setPrompt = () => {
        setThePrompt(
            // <Prompt
            //     // when={shouldBlockNavigation}
            //     message={(location, action) => {
            //         if (order.Orders?.length > 0) {
            //             return false;
            //         }
            //         else {
            //             sessionStorage.setItem("restPage", "");
            //             return true;
            //         }

            //     }}
            // />
        )
    }

    //פותח את מסך בחירת ההזמנה ישירות במצב "עתידי בלבד" - "עכשיו" ממילא לא
    //אפשרי כי העסק סגור כרגע. אותו pattern בדיוק כמו ContinueToPayLine.nextPage.
    const openFutureOrderPopup = () => {
        setThePopUp(
            <PopUpTheComp
                closePop={() => { setThePopUp() }}
                cssStyl={"addressSelectPop"}
                theInsideComp={
                    <OrderTypeSelect
                        forceFutureMode={true}
                        shoTopStrp={(tf) => props.shoTopStrp && props.shoTopStrp(tf)}
                        scrollToTop={(stUp) => { }}
                        showfotter={(fot) => { }}
                        closePop={() => { setThePopUp() }}
                        setShowbanners={(bol) => { }} />}
                Title={[""]}
            />
        )
    }

    const getLineDoOrNot = () => {

        //השוואה מול הקונסטנטה המיוצאת ולא מול מחרוזת מקומית -
        //קודם היו שתי גרסאות של הטקסט, עם ובלי רווח, וההשוואה
        //הזו תפסה רק אחת מהן ולכן העיצוב הזה לא הופיע
        if (notGettinOrders === myFunctions.STRIP_ONLY_PICKUP) {
            return (
                <div data-nosnippet className={"no-render imgWrapDivCloseFixed2"}>
                    <span>{notGettinOrders}</span>
                </div>
            )
        }
        //סגור עכשיו אבל יש הזמנה עתידית זמינה - הבאנר השחור הופך ללחיץ,
        //אותו עיצוב בדיוק (אין באנר חדש/כפתור נוסף) - לוחצים ופותח ישר
        //את מסך בחירת ההזמנה במצב עתידי, כי הבאנר הזה תמיד מכסה את
        //ContinueToPayLine כשסגור כך שהוא ממילא הנקודה היחידה הנגישה.
        else if (notGettinOrders === myFunctions.STRIP_CLOSED_FUTURE_ONLY) {
            return (
                <div data-nosnippet className={"no-render imgWrapDivCloseFixed pointing"} onClick={() => openFutureOrderPopup()}>
                    <span>{notGettinOrders}</span>
                </div>
            )
        }
        else if (notGettinOrders !== "") {
            return (
                <div data-nosnippet className={"no-render imgWrapDivCloseFixed"}>
                    <span>{notGettinOrders}</span>
                </div>
            )
        }
    }

    const redirectUs = () => {
        setOrder(OrderFunctions.clearOrd());
        // כתובת חיצונית בתוך האפליקציה (מגרסה 1.0.11) - נפתחת בחוץ
        if (isExternalUrl(currentPage.buissRedirecting) && openViaApp(currentPage.buissRedirecting)) return;
        window.location.href = currentPage.buissRedirecting;
    }



    let onlyPhoneOrders = (currentPage.buissIsOnline != null && currentPage.buissIsOnline) ? "" : "כרגע, הזמנות טלפונית";

    // עסק שמקבל הזמנת שולחן אבל אי אפשר להזמין ממנו אוכל.
    // במצב הזה הפס "לא ניתן לבצע הזמנות" מטעה — יש מה להזמין, רק לא אוכל.
    //
    // התנאי נגזר מ-reservationOnlyStrip ולא ממתגי ה-Doing בלבד, ולכן
    // הוא מכסה גם מחוץ לשעות הערוצים, יום חריג, חסימה במאסטר והשהיות -
    // בדיוק המצבים שבהם הזמנת שולחן עדיין אפשרית כי היא הזמנה עתידית.
    const isReservationOnly = reservOnlyTxt !== "";

    return (
        <div className="inerPage">

            <WaitImgOverlay item={waitImgItm} ready={!!restMnu} />

            {waitImgItm?.active !== false && !restMnu ? <MySpinner_Wait /> :
                <div className={"restWrap"}>

                    {/* {stickyShow ? <>
                        <div id="stickeySideMsg" className={"stickeySideMsg"} style={{
                            left: mousePosi.x,
                            top: mousePosi.y,
                            backgroundImage: `url(${ConnUrls.media('Uploads/MASTER/onlne.png')})`,
                            backgroundPosition: `${waitImgItm.imgBackPos}`,
                            backgroundSize: `85%`,
                            backgroundRepeat: `${waitImgItm.backgroundRepeat}`
                        }}
                            onMouseDown={() => setMov(true)}
                            onMouseUp={() => setMov(false)}>
                            //{mov ? <MovingOnScreen whenMove={(posi) => movposi(posi)} /> : ""} //
                            <CancelRounded className={"HighlightOffSticky pointing"} onClick={() => setStickyShow(false)} />
                        </div>

                    </>
                        : ""} */}

                    {(mobiOrNot) ?
                        <div className={`backSdOnlyBtn`}> <ArrowCircleRightSharp onClick={() => goToBack()} /></div>
                        : ""}

                    <div className={"mainRestP posRelative"}>

                        <img className={!mobiOrNot && buissMainImgDeskTop2 ? "imgRestDivImg1" : "imgRestDivImg"}
                            src={`${ConnUrls.media((!mobiOrNot && buissMainImgDeskTop != null) ?
                                buissMainImgDeskTop : buissMainImg)}`} alt={currentPage.buissName} />
                        {!mobiOrNot && buissMainImgDeskTop2 &&
                            <img className={"imgRestDivImg2"} src={`${ConnUrls.media(buissMainImgDeskTop2)}`} alt={currentPage.buissName} />

                        }

                    </div>

                    <div className={"restDetailsBlk"}>
                        <div className={"restPHeads"}>
                            <div className="fullRow overflowHid spaceButtomBig">
                                <h1 className={"restHeader HeaderFont anakMeod"}>{currentPage.buissName}</h1>
                                {/* <p className="onPhoneP">{onlyPhoneOrders}</p> */}
                                {currentPage.buisReservation && <>
                                    <div onClick={() => orderMeATable()} className="OrderTableBtn pointing">
                                        הזמנת שולחן
                                    </div>
                                </>
                                }
                            </div>
                            {(currentPage.buissRedirecting && currentPage.buissRedirecting !== "") ?
                                <div onClick={() => redirectUs()}>
                                    <div className={`restSubHeader ${!mobiOrNot ? "buissRedirectingBtn" :
                                        "OrderTableBtn"} big spaceTop`}>{currentPage.buissKitchType}</div>
                                </div>

                                :
                                <div className={"restSubHeader big spaceTop"}>{currentPage.buissKitchType}</div>

                            }
                            <div className={"detailsLine kosherLine mediumst spaceTop"}>
                                <div> {currentPage.txtBuisKosher}</div>
                            </div>

                        </div>

                        {(mobiOrNot) ?
                            <>
                                <div className={"rSideMedBig"}>
                                    {openingHours}
                                    {buisAddress}
                                    {delTiming}
                                    {rating}

                                </div>
                                <div className={"lSideMedSmall"}>
                                    {lsidetuff}
                                </div>
                            </>
                            : ""}
                    </div>


                    {restMnu}

                </div>

            }

            {
                (order?.restId === currentPage._id) &&
                <ContinueToPayLine
                    doDeliver={doDeliver}
                    doTakeAway={doTakeAway}
                    master={master}
                    theTxt={"המשך להזמנה"}
                    withPrice={true}
                />

            }

            {
                <MoreDetails showMe={shHidMoreDetails} currP={currentPage}
                    setShowMe={() => setShHidMoreDetails(!shHidMoreDetails)}
                    popMoreDetails={() => popMoreDetails()} />
            }

            {thePopUp}

            {isReservationOnly ?
                <div data-nosnippet className={"no-render imgWrapDivCloseFixed"}>
                    <span>{reservOnlyTxt}</span>
                </div>
                : (currentPage?.buissIsOnline === false) ?
                    <div data-nosnippet className={"no-render imgWrapDivCloseFixed"}>
                        <span>לא ניתן לבצע הזמנות בעסק זה</span>
                    </div> :
                    getLineDoOrNot()
            }

            <ScrollingSaver pagNam={"restPage"} contentReady={!!restMnu} />

            <Helmet
                meta={[
                    {
                        property: "og:url", content:
                            // `${ConnUrls.siteDomainNam}/restaurants/${encodeURIComponent(currentPage.pageUrlFix)}`
                            `${ConnUrls.siteDomainNam}/restaurants/${currentPage.pageUrlFix}`
                                !== null &&
                                encodeURIComponent(currentPage.pageUrlFix) !== "" ?
                                `${ConnUrls.siteDomainNam}/restaurants/${encodeURIComponent(currentPage.pageUrlFix)}` :
                                currentPage._id
                    }
                ]}>



                <link rel="canonical"
                    href={currentPage.pageUrlFix !== null && currentPage.pageUrlFix !== "" ?
                        `${ConnUrls.siteDomainNam}/restaurants/${encodeURIComponent(currentPage.pageUrlFix)}` :
                        `${ConnUrls.siteDomainNam}/restaurants/${currentPage._id}`} />

                <script className='structured-data-list' type="application/ld+json">{googleSchem}</script>
                {breadcrumbSchema && <script type="application/ld+json">{breadcrumbSchema}</script>}
            </Helmet>
        </div >
    );
}

export default RestaurantPage;
